import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreateManagementReportAccountingRequestDto } from '@domain/management-report-accounting/dtos/create-management-report-accounting.request.dto';
import { ListManagementReportAccountingRequestDto } from '@domain/management-report-accounting/dtos/list-management-report-accounting.request.dto';
import { ManagementReportAccountingResponseDto } from '@domain/management-report-accounting/dtos/management-report-accounting.response.dto';
import { UpdateManagementReportAccountingRequestDto } from '@domain/management-report-accounting/dtos/update-management-report-accounting.request.dto';
import { ValidateErpManagementReportAccountingResponseDto } from '@domain/management-report-accounting/dtos/validate-erp-management-report-accounting.response.dto';

@Injectable({
  providedIn: 'root',
})
export class ManagementReportAccountingService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('management/report-accounting');
  }

  list(request: ListManagementReportAccountingRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<ManagementReportAccountingResponseDto>>
    >(queryUrl, { params: { ...request } });
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<ManagementReportAccountingResponseDto>>(
      queryUrl,
    );
  }

  create(request: CreateManagementReportAccountingRequestDto) {
    const queryUrl = this.getApiUrl();
    return this.http.post<ApiResponse<ManagementReportAccountingResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateManagementReportAccountingRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<ManagementReportAccountingResponseDto>>(
      queryUrl,
      request,
    );
  }

  delete(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.delete<ApiResponse<void>>(queryUrl);
  }

  validateErp(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/validate-erp`;
    return this.http.get<
      ApiResponse<ValidateErpManagementReportAccountingResponseDto>
    >(queryUrl);
  }
}
